import { render, staticRenderFns } from "./course-radio-group.vue?vue&type=template&id=0d499b34&scoped=true&"
import script from "./course-radio-group.vue?vue&type=script&lang=js&"
export * from "./course-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./course-radio-group.vue?vue&type=style&index=0&id=0d499b34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d499b34",
  null
  
)

export default component.exports